export default {
    setCache(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
    },
    getCache(key) {
        return JSON.parse(sessionStorage.getItem(key));
    },
    clearCache(key) {
        return sessionStorage.removeItem(key);
    },
    clear() {
        return sessionStorage.clear();
    }
};
